import type { TimelineInternalOps } from '../timelineInternalOps';
import type { UndoHelper } from '../utils/undoHelper';


export function getUniqueId(undoHelper: UndoHelper, timelineHelper: TimelineInternalOps): string {
  const tmpId: string[] = [];
  undoHelper.add(timelineHelper.createUniqueId(tmpId));
  return tmpId.splice(0, 1)[0];
}
